import React, { useEffect, useState } from "react";
import Dialog from "../Dialog";
import { useSelector } from "react-redux";
import { useAccount} from "wagmi";
import Lottie from "lottie-react";
import Disconnected from "../../animations/disconnected.json";
import Countdown from "react-countdown";
import Button from "../Button";
import { useWeb3Modal } from "@web3modal/wagmi/react";
import { useLocation } from "react-router-dom";
import { useAppTranslation } from "../../i18n/useAppTranslation";

const DisconnectDialog = ({ handleLogout }: { handleLogout: () => void }) => {
  const { t } = useAppTranslation(["common", "errors"]);
  const userInfo = useSelector((state: any) => state.userInfo);
  const [open, setOpen] = useState(false);
  const [timer, setTimer] = useState<Date | null>();
  const { isDisconnected, isReconnecting, isConnected } = useAccount();
  const { open: openW3M } = useWeb3Modal();
  const location = useLocation();

  const requiresConnection = () => {
    const path = location.pathname;
    const connectionRequiredPaths = [
      '/profile',
      '/marketplace',
      '/lands',
      '/my-lands',
      '/trade',
      '/transaction-history',
      '/withdraw-history',
      '/barracks',
      '/adventure',
      '/arena',
      '/dao',
      '/referrals',
      '/mint-lands',
      '/growth',
      '/guild',
      '/treasure',
      '/dungeon',
      '/battle',
      '/village',
      '/research'
    ];
    return connectionRequiredPaths.some(requiredPath => path.startsWith(requiredPath));
  };

  useEffect(() => {
    if (
      localStorage.getItem("connector") === "walletconnect" &&
      isDisconnected &&
      userInfo &&
      !isReconnecting &&
      requiresConnection()
    ) {
      setOpen(true);
      setTimer(new Date(Date.now() + 59000));
    }
  }, [isDisconnected, isReconnecting, location.pathname]);
  useEffect(() => {
    if (isConnected && open) {
      setOpen(false);
      setTimer(null);
    }
  }, [isConnected]);
  return (
    <Dialog
    force
      disableSubmit
      noFooter
      title={t("errors:disconnectDialog.title")}
      open={open}
      
      onClose={() => null}
    >
      <div style={{ marginBottom: -40 }} className="d-flex  flex-column gap-2">
        <div className="w-100 ">
          <Lottie
            style={{ height: 300, marginTop: -50 }}
            animationData={Disconnected}
            autoPlay
            loop
          />
        </div>
        <div className="fs-big text-center ">
          {t("errors:disconnectDialog.walletDisconnected")}
        </div>
        <div className="fs-med">
          {t("errors:disconnectDialog.messagePrefix")}
          <span className="text-info">
            {" "}
            {t("errors:disconnectDialog.unlockWallet")}{" "}
          </span>
          {t("errors:disconnectDialog.messageSuffix")}
        </div>

        {timer && (
          <Countdown
            date={timer}
            renderer={({ formatted }) => (
              <>
                <div className="fs-bigger bold text-center text-danger">
                  {formatted.seconds}
                </div>
              </>
            )}
              onComplete={() => {
                setOpen(false)
                handleLogout();
                setTimer(null)
              }}
          />
        )}
        <div className="d-flex mt-2 gap-2 justify-content-center align-items-center">
          <Button onClick={()=>openW3M({view:'Connect'})} className="bg-100" variant="wide-primary">
            {t("errors:disconnectDialog.reconnect")}
          </Button>
          <Button
            onClick={handleLogout}
            className="bg-100"
            variant="wide-secondary"
          >
            {t("errors:disconnectDialog.disconnect")}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default DisconnectDialog;
